// extracted by mini-css-extract-plugin
export default {"holder":"Homepage_holder__9UztL","carouselMainHolder":"Homepage_carouselMainHolder__AXxaj","HomeGridHolder":"Homepage_HomeGridHolder__xfZ1F"};